import { post, get } from 'api'

export const login = (username, password) => post('/account/signin', { username, password })

export const logout = () => post('/account/signout')

export const getUser = () => get('/account/userinfo')
